/*
 * WHAT TO DO FROM HERE — the quiet line in the corner.
 *
 * This was one nudge for a newcomer: a bubble across the bottom edge saying "tap a name to open it",
 * dismissed on the first tap and never seen again. The reasoning was sound — a canvas gives a
 * newcomer nothing that looks clickable — and their answer to the same problem is better in three
 * ways, so it is theirs now (engine.js:2090, ported in `v8/hint.ts`):
 *
 *   it never covers the map    two lines of small text in the corner, not a bubble across the middle
 *   it is never stale          the line follows the range, so it answers the question a reader has
 *                              NOW rather than the one they had on their first visit
 *   it explains the dark       at the widest view it says what the darkness IS, which is the map's
 *                              central metaphor and the one thing nothing else here says out loud
 *
 * The dismiss stays. A reader who wants a bare field should be able to have one, and that was always
 * the right half of the original.
 */
import { useLang } from '../i18n/lang';
import type { Hint } from './v8/hint';

/** Which phrase each state reads, so the mechanism stays in `v8/hint.ts` and the words stay here. */
const SAYS = {
  flying: 'hint.flying',
  dark: 'hint.dark',
  zoomIn: 'hint.zoomIn',
  tap: 'hint.tap',
} as const;

export interface MapHintProps {
  onDismiss: () => void;
  /** Which line to show. Absent means the caller has no camera to ask — the old one-shot wording. */
  hint?: Hint;
}

export function MapHint({ onDismiss, hint }: MapHintProps): React.JSX.Element {
  const { t } = useLang();
  return (
    <div className="map-hint" role="note" data-map-chrome>
      {/* And the dismiss, which read back as "tap a name to open its verses×" — the phrase this
          map is judged on with a control welded to the end of it. `hint-v8` compares that phrase
          against theirs word for word. */}
      <span>{t(hint === undefined ? 'hint.text' : SAYS[hint])}</span>{' '}
      <button type="button" className="map-hint-dismiss" onClick={onDismiss} aria-label={t('hint.dismiss')}>×</button>
    </div>
  );
}
